// assets/text-format-fix.js
document.addEventListener('DOMContentLoaded', ()=>{
  const els = document.querySelectorAll('.js-format-fix');
  if (!els.length) return;
  
  const BAD_CHARS = /\u00C2\u0095|\u0095|\u00C2/g;
  
  els.forEach(el => {
    const cleanHTML = el.textContent
      .replace(BAD_CHARS, '<br>&bull;&nbsp;')
      .replace(/(composizione)/i, '<br>&bull;&nbsp;$1');
    el.innerHTML = cleanHTML;
  });

});